/**
 * Duración de las llamadas al backend que pasan por la capa HTTP común
 * (`HTTPService.fetchRequest`). La telemetría se suscribe para mandar
 * `api_slow` (más de 3 s); la capa HTTP no sabe nada de ella. Un observador que
 * falla nunca afecta a la llamada.
 */
export type RequestTimingObserver = (url: string, ms: number) => void;

let observer: RequestTimingObserver | null = null;

/** Registra el observador (uno solo). Devuelve la función para quitarlo. */
export const setRequestTimingObserver = (fn: RequestTimingObserver): (() => void) => {
  observer = fn;
  return () => {
    if (observer === fn) observer = null;
  };
};

export const reportRequestTiming = (url: string, ms: number): void => {
  try {
    observer?.(url, ms);
  } catch {
    /* la telemetría nunca rompe una llamada */
  }
};
